<template>
  <div class="card">
    <h3>Luo uusi yritys</h3>
    <form @submit.prevent="createCompany">
      <base-input
        type="text"
        name="name"
        label="Yrityksen nimi"
        v-model="name"
        :errors="errors.name"
      />
      <LogoUpload
        :company="getId(name)"
        :disabled="companyExists"
        @status-updated="onFileStatusUpdated"
      />
      <ColorPicker
        v-model="highlight"
      />
      <transition-group
        v-if="categories.length"
        name="list"
        class="categories"
        tag="ul"
        mode="out-in"
      >
        <li
          v-for="category in categories"
          :key="category.title"
          :style="{ backgroundColor: category.background }"
        >
          {{ category.title }}
          <span class="delete" @click="deleteCategory(category)"></span>
        </li>
      </transition-group>
      <base-input
        type="text"
        name="category"
        label="Lisää kategoria"
        v-model="category.title"
        @onClick="addCategory"
        button="Tallenna kategoria"
        :blue="true"
        :errors="errors.category"
      />
      <button type="submit" class="button button__rounded button__submit" :disabled="uploading || companyExists || !logoUrl || !name || categories.length == 0">
        <span>Lisää uusi yritys</span>
      </button>
    </form>
    <div class="spinner" v-if="uploading">
      <Loader />
    </div>
  </div>
</template>

<script>
import db from "@/firebase/init";
import slugify from "slugify";

import BaseInput from "@/components/BaseInput";
import LogoUpload from "@/components/LogoUpload";
import ColorPicker from "@/components/ColorPicker";
import Loader from "@/components/Loader";

export default {
  name: "AddCompany",
  components: {
    BaseInput,
    LogoUpload,
    Loader,
    ColorPicker
  },
  data() {
    return {
      id: null,
      name: null,
      image: null,
      colors: ["#2677c2", "#26c285", "#ece34d", "#fcb039", "#fc553a"],
      used: false,
      category: {
        title: null,
        background: null
      },
      categories: [],
      errors: {},
      uploading: false,
      logoUrl: null,
      companyExists: false,
      color: null,
      highlight: null,
    };
  },
  watch: {
    name() {
      if(this.name && this.name !== '') {
        const usersRef = db.collection('companies').doc(this.getId(this.name))

        usersRef.get()
          .then((docSnapshot) => {
            if (docSnapshot.exists) {
              this.companyExists = true;
              this.errors.name = "Yritys on jo olemassa.";
            } else {
              this.errors.name = "";
              this.companyExists = false;
            }
        });
      } else {
        this.errors.name = "";
        this.companyExists = false;
      }
    }
  },
  methods: {
    createCompany() {
      this.id = this.getId(this.name);
      const newCompany = {
        id: this.id,
        name: this.name,
        image: this.logoUrl,
        categories: this.categories,
        slug: this.id,
        highlight: this.highlight
      };
      db.collection("companies")
        .doc(this.id)
        .set(newCompany)
        .then(() => {
          this.name = '';
          this.logoUrl = null;
          this.categories = [];
          this.id = '';

          console.log("Yritys on luotu.");
        })
        .catch(err => {
          console.log("Error: ", err);
        });
    },
    getNextFreeColor() {
      if (this.categories.length > 0) {
        for (let i = 0; i < this.colors.length; i++) {
          this.used = false;
          for (let j = 0; j < this.categories.length; j++) {
            if (this.colors[i] === this.categories[j].background) {
              this.used = true;
              break;
            }
          }
          if (!this.used) {
            this.color = this.colors[i];
            break;
          }
        }
      } else {
        this.color = this.colors[0];
      }
      return this.color;
    },
    addCategory() {
      if (this.category) {
        this.category = {
          title: this.category.title,
          background: this.getNextFreeColor()
        };
        this.categories.push(this.category);
        this.category = {};
        this.errors.category = null;
      } else {
        this.errors.category = "Virhe.";
      }
    },
    deleteCategory(category) {
      this.categories = this.categories.filter(cat => {
        return cat !== category;
      });
    },
    getId(name) {
      if(name === null || name === '') {
        return '';
      }
      return slugify(name, {
        replacement: "-",
        remove: /[$*_+~()'"!\-:@]/g,
        lower: true
      });
    },
    onFileStatusUpdated(status) {
      if(status.status == "uploading") {
        this.uploading = true;
      }
      if(status.url) {
        this.uploading = false;
        this.logoUrl = status.url;
      }
    },
  }
};
</script>
<style lang="scss" scoped>
.card {
  position: relative;

  .spinner {
    border-radius: 1.5rem;
    margin: auto;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: #44444473;
  }
}
</style>